<template>
  <div class="page">
    <van-nav-bar title="注册" left-arrow @click-left="$router.replace('/login')" />
    <van-form @submit="onSubmit">
      <van-field v-model="form.phone" label="手机号" maxlength="11" placeholder="请输入手机号" :rules="[{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }]" />
      <van-field v-model="form.password" type="password" label="密码" placeholder="6到20位密码" :rules="[{ required: true, message: '请输入密码' }]" />
      <van-field v-model="form.nickname" label="昵称" maxlength="50" placeholder="可不填" />
      <van-field v-model="form.inviteCode" label="邀请码" placeholder="请输入邀请码" />
      <div class="btn"><van-button round block type="info" native-type="submit">注册并登录</van-button></div>
    </van-form>
  </div>
</template>

<script>
import { register, saveAuth } from '../api'

export default {
  data() {
    return { form: { phone: '', password: '', nickname: '', inviteCode: this.$route.query.code || '' } }
  },
  methods: {
    onSubmit() {
      register(this.form).then(res => {
        saveAuth(res.data)
        this.$toast('注册成功')
        this.$router.replace('/')
      })
    }
  }
}
</script>

<style scoped>
.btn { margin: 24px 16px; }
</style>
